import React from 'react';
import ReactDOM from 'react-dom/client';
import SunnyBlondeHouseApp from './the_sunny_blonde_house.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SunnyBlondeHouseApp />
  </React.StrictMode>
);
